export default "__VITE_ASSET__h4yKI8Y6__"